module.exports = __webpack_public_path__ + "0c53ea1c92a9656e0638d46a8463e635.pdf";